import { LegalLayout } from '../../components/LegalLayout';
import { t } from '../../hooks/useT';
import { LegalBody } from './LegalBodies';

export function MentionsLegalesPage() {
  return (
    <LegalLayout title={t('legal.mentions.title')} lead={t('legal.mentions.lead')}>
      <LegalBody page="mentions" />
    </LegalLayout>
  );
}
